$(function() {

    const swiperThumbs = new Swiper('#swiper-thumbs', {
        slidesPerView: 3.5,
        spaceBetween: 10,
    });   
    const swiperProducts = new Swiper('#swiper-products', {
        
        thumbs: {
            swiper: swiperThumbs
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoHeight: true,
            },
            993: {
                effect: 'slide',
                slidesPerView: 1,
                allowTouchMove: false,
                autoHeight: false,
            }
        },
    });

    $(document).ready(function () {
        const scrollLinks = $(".scroll-detect");
        const images = $("#swiper-products .swiper-slide img");

        // Function to detect which image is at the top of the viewport
        function onScroll() {
            let activeIndex = -1;

            images.each(function (index) {
                const rect = this.getBoundingClientRect();
                if (rect.top >= 0 && rect.top <= 100) { 
                    activeIndex = index;
                }
            });

            scrollLinks.each(function (index) {
                if (index === activeIndex) {
                    scrollLinks.removeClass("active");
                    $(this).addClass("active");
                } 
            });
        }

        $(window).on("scroll", onScroll);
    });

    
});